import { Membership } from 'types/membership';

function timestampMs(value: string | undefined): number {
  if (!value) return 0;
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? 0 : t;
}

/**
 * Enforces the membership history contract: versions sorted by `updatedAt`
 * descending (newest first), using `createdAt` when `updatedAt` is missing.
 */
export function sortMembershipHistoryByUpdatedAtDesc(
  versions: Membership[],
): Membership[] {
  return [...versions].sort((a, b) => {
    const tb = timestampMs(b.updatedAt ?? b.createdAt);
    const ta = timestampMs(a.updatedAt ?? a.createdAt);
    if (tb !== ta) return tb - ta;
    return b.id.localeCompare(a.id);
  });
}
